/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/attachments/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import { AmoNotification, AmoNotificationFromJSON, AmoNotificationToJSON } from './AmoNotification';

/**
 *
 * @export
 * @interface InlineResponse20012
 */
export interface InlineResponse20012 {
  /**
   *
   * @type {number}
   * @memberof InlineResponse20012
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof InlineResponse20012
   */
  previous?: string | null;
  /**
   *
   * @type {Array<AmoNotification>}
   * @memberof InlineResponse20012
   */
  results: Array<AmoNotification>;
}

export function InlineResponse20012FromJSON(json: any): InlineResponse20012 {
  return InlineResponse20012FromJSONTyped(json, false);
}

export function InlineResponse20012FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20012 {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    count: json['count'],
    next: !exists(json, 'next') ? undefined : json['next'],
    previous: !exists(json, 'previous') ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(AmoNotificationFromJSON),
  };
}

export function InlineResponse20012ToJSON(value?: InlineResponse20012 | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    count: value.count,
    next: value.next,
    previous: value.previous,
    results: (value.results as Array<any>).map(AmoNotificationToJSON),
  };
}
